import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import { ContentContainer, ContentCircularLoader } from '@libComponents';

import TimesheetViewSwitcher from './TimesheetViewSwitcher';
import { useTimesheetViewSwitcher } from './hooks';
import { Button } from '@mui/material';
import TimesheetExportModal from '../TimesheetExportModal';
import { useState } from 'react';

const propTypes = {
    ContentComponent: PropTypes.elementType.isRequired,
    title: PropTypes.string,
    loading: PropTypes.bool
};

const StyledBox = styled(Box)({
    position: 'relative'
});

const TimesheetsContainer = ({ ContentComponent, loading, viewOptions, showExportButton = false }) => {
    const { viewType, handleTimesheetViewChange, selectedTimesheetView } =
        useTimesheetViewSwitcher();
    const [openExportModal, setOpenExportModal] = useState(false);

    return (
        <StyledBox>
            {loading && <ContentCircularLoader />}
            {showExportButton &&
                <Button
                    variant='contained'
                    color='primary'
                    sx={{ mb: 2 }}
                    onClick={() => setOpenExportModal(true)}
                >
                    Export Attendance
                </Button>
            }
            <ContentContainer
                title={selectedTimesheetView}
                headerBg='transparent'
                AdornmentComponent={
                    <TimesheetViewSwitcher
                        selectedView={viewType}
                        onViewChange={handleTimesheetViewChange}
                        viewOptions={viewOptions}
                    />
                }
            >


                {/* 🔹 Modal Component */}
                <TimesheetExportModal
                    open={openExportModal}
                    onClose={() => setOpenExportModal(false)}
                    view={viewType}
                />

                <ContentComponent currentView={viewType} />
                {/* 🔹 Export Button */}
            </ContentContainer>

        </StyledBox>
    );
};

TimesheetsContainer.propTypes = propTypes;

export { TimesheetsContainer as default, TimesheetsContainer };
